var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19393"
}, /*#__PURE__*/React.createElement("path", {
  fill: "rgba(0,0,0,0)",
  d: "M16 0A16 16 0 1 1 0 16 16 16 0 0 1 16 0",
  "data-name": "Path 27349"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 15460"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28 28V4H4v24Z",
  "data-name": "Path 5191",
  opacity: 0.01
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  "data-name": "Group 15202"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.87 22.31h-8a5 5 0 0 1 0-10h11",
  "data-name": "Path 5192"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.57 14.81 2.56-2.56-2.56-2.56",
  "data-name": "Path 5193"
}))))));
export { SvgChatForward as ReactComponent };
export default __webpack_public_path__ + "static/media/chat_forward.37c27b794e464a61e1a979d81df19b77.svg";